var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33398C15.1459 3.34407 16.1274 3.42445 16.7678 4.06477C17.5 4.797 17.5 5.97551 17.5 8.33254V13.3325C17.5 15.6896 17.5 16.8681 16.7678 17.6003C16.0355 18.3325 14.857 18.3325 12.5 18.3325H7.5C5.14298 18.3325 3.96447 18.3325 3.23223 17.6003C2.5 16.8681 2.5 15.6896 2.5 13.3325V8.33254C2.5 5.97551 2.5 4.797 3.23223 4.06477C3.87255 3.42445 4.85414 3.34407 6.66667 3.33398",
    stroke: "#7F8594",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.666L14.1667 11.666",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 11.666H6.25065",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 8.75H6.25065",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 14.584H6.25065",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.75H14.1667",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 14.584H14.1667",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 2.91602C6.66602 2.22566 7.22566 1.66602 7.91602 1.66602H12.0827C12.773 1.66602 13.3327 2.22566 13.3327 2.91602V3.74935C13.3327 4.4397 12.773 4.99935 12.0827 4.99935H7.91602C7.22566 4.99935 6.66602 4.4397 6.66602 3.74935V2.91602Z",
    stroke: "#7F8594",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.681de6b8.svg";
export { ForwardRef as ReactComponent };